import UserPreferencesRepository from '../application/ports/UserPreferencesRepository';
import {
  mapUserPreferencesDomainToDto,
  mapUserPreferencesDtoToDomain,
} from './mappers/userPreferencesMapper';

const buildUserPreferencesError = error => {
  const detail = error?.response?.data?.detail;
  const err = new Error(detail || error.message || 'User preferences request failed');
  err.status = error?.response?.status;
  err.data = error?.response?.data;
  return err;
};

class RestUserPreferencesRepository extends UserPreferencesRepository {
  constructor({ axiosInstance, apiPath = '/api/user/preferences/' } = {}) {
    super();
    if (!axiosInstance) {
      throw new Error('RestUserPreferencesRepository requires an axiosInstance');
    }

    this.axiosInstance = axiosInstance;
    this.apiPath = apiPath;
  }

  async getUserPreferences() {
    try {
      const response = await this.axiosInstance.get(this.apiPath);
      return mapUserPreferencesDtoToDomain(response.data);
    } catch (error) {
      throw buildUserPreferencesError(error);
    }
  }

  async updateUserPreferences(userPreferences) {
    try {
      const response = await this.axiosInstance.patch(
        this.apiPath,
        mapUserPreferencesDomainToDto(userPreferences)
      );
      return mapUserPreferencesDtoToDomain(response.data);
    } catch (error) {
      throw buildUserPreferencesError(error);
    }
  }
}

export default RestUserPreferencesRepository;
